const TANavbarStrings = {
  en: {
    appName: "TA Connect",
    navigation: {
      profile: "Profile",
      createSlot: "Create Slot",
      manageCourses: "Manage Slots",
      manageBookings: "Manage Bookings",
      pendingBookings: "Pending Bookings",
      settings: "Settings",
      logout: "Logout",
      dashboard: "Dashboard",
      emailPreferences: "Email Preferences",
    },

    user: {
      defaultName: "User",
      taPortal: "TA Portal",
      emailNotVerified: "Email not verified. Please verify your account.",
    },

    aria: {
      toggleNav: "Toggle navigation sidebar",
      expandSidebar: "Expand sidebar",
      collapseSidebar: "Collapse sidebar",
    },

    emailPreferences: {
      title: "Email Notifications",
      bookingLabel: "Email on Booking",
      bookingDescription: "Get notified when students book a session",
      cancellationLabel: "Email on Cancellation",
      cancellationDescription: "Get notified when sessions are cancelled",
      updateLabel: "Email on Booking Update",
      updateDescription: "Get notified when students update or reschedule their bookings",
      save: "Save Preferences",
      saving: "Saving...",
      saved: "Preferences saved successfully",
      error: "Failed to save preferences",
      fetchError: "Failed to load preferences",
      resetSuccess: "Preferences reset to default",
      loading: "Loading preferences...",
      manageSettings: "Manage your email notification settings",
      resetToDefault: "Reset to Default",
      enabled: "Enabled",
      receiveBookingEmail: "Receive email when a student books your office hours",
      receiveCancelEmail: "Receive email when a student cancels a booking",
      receiveUpdateEmail: "Receive email when a student updates or reschedules a booking",
    },

    pushNotifications: {
      title: "Push Notifications",
      enable: "Enable Push Notifications",
      disable: "Disable Push Notifications",
      enabled: "Push notifications are enabled",
      disabled: "Push notifications are disabled",
      notSupported: "Push notifications are not supported in this browser",
      permissionDenied: "Notification permission was denied",
      subscribeSuccess: "Successfully subscribed to push notifications",
      unsubscribeSuccess: "Successfully unsubscribed from push notifications",
      error: "Failed to update push notification settings",
      description: "Receive instant notifications for booking updates",
    }
  },
  ar: {
    appName: "TA Connect",
    navigation: {
      profile: "الملف الشخصي",
      createSlot: "إنشاء موعد",
      manageCourses: "إدارة المواعيد",
      manageBookings: "إدارة الحجوزات",
      pendingBookings: "الحجوزات المعلقة",
      settings: "الإعدادات",
      logout: "تسجيل الخروج",
      dashboard: "لوحة التحكم",
      emailPreferences: "إعدادات البريد الإلكتروني",
    },

    user: {
      defaultName: "المستخدم",
      taPortal: "بوابة TA",
      emailNotVerified: "البريد الإلكتروني غير موثق. يرجى التحقق من حسابك.",
    },

    aria: {
      toggleNav: "تبديل شريط التنقل الجانبي",
      expandSidebar: "توسيع الشريط الجانبي",
      collapseSidebar: "طي الشريط الجانبي",
    },

    emailPreferences: {
      title: "إشعارات البريد الإلكتروني",
      bookingLabel: "البريد عند الحجز",
      bookingDescription: "احصل على إشعار عندما يحجز الطلاب جلسة",
      cancellationLabel: "البريد عند الإلغاء",
      cancellationDescription: "احصل على إشعار عند إلغاء الجلسات",
      updateLabel: "البريد عند تحديث الحجز",
      updateDescription: "احصل على إشعار عندما يقوم الطلاب بتحديث أو إعادة جدولة حجوزاتهم",
      save: "حفظ التفضيلات",
      saving: "جارِ الحفظ...",
      saved: "تم حفظ التفضيلات بنجاح",
      error: "فشل حفظ التفضيلات",
      fetchError: "فشل تحميل التفضيلات",
      resetSuccess: "تم إعادة تعيين التفضيلات إلى الافتراضية",
      loading: "جارِ تحميل التفضيلات...",
      manageSettings: "إدارة إعدادات إشعارات البريد الإلكتروني",
      resetToDefault: "إعادة تعيين إلى الافتراضي",
      enabled: "مفعّل",
      receiveBookingEmail: "استلام بريد إلكتروني عندما يحجز طالب ساعاتك المكتبية",
      receiveCancelEmail: "استلام بريد إلكتروني عندما يلغي طالب حجزاً",
      receiveUpdateEmail: "استلام بريد إلكتروني عندما يحدث طالب أو يعيد جدولة حجز",
    },

    pushNotifications: {
      title: "إشعارات الدفع",
      enable: "تفعيل إشعارات الدفع",
      disable: "إلغاء تفعيل إشعارات الدفع",
      enabled: "إشعارات الدفع مفعّلة",
      disabled: "إشعارات الدفع غير مفعّلة",
      notSupported: "إشعارات الدفع غير مدعومة في هذا المتصفح",
      permissionDenied: "تم رفض إذن الإشعارات",
      subscribeSuccess: "تم الاشتراك في إشعارات الدفع بنجاح",
      unsubscribeSuccess: "تم إلغاء الاشتراك في إشعارات الدفع بنجاح",
      error: "فشل تحديث إعدادات إشعارات الدفع",
      description: "تلقي إشعارات فورية لتحديثات الحجز",
    }
  }
};

export default TANavbarStrings;
